"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderContainer = exports.StyledAccordion = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const accordions_1 = require("@kyruus/accordions");
const styles_1 = require("../common/styles");
const styledAccordionOptions = {
    shouldForwardProp: (propName) => propName !== 'type'
};
exports.StyledAccordion = (0, styled_1.default)(accordions_1.Accordion, styledAccordionOptions) `
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root,
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root.Mui-expanded,
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root.Mui-focused.Mui-focusVisible,
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root.Mui-expanded.Mui-focused.Mui-focusVisible {
    background-color: ${(props) => (0, ui_theme_1.fromTheme)(styles_1.bannerTypeColorMap[props.type].background)(props)};
    border-color: ${(props) => (0, ui_theme_1.fromTheme)(styles_1.bannerTypeColorMap[props.type].border)(props)};
    transition: border 0s;
  }
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root.Mui-focused.Mui-focusVisible,
  .MuiAccordionSummary-root.MuiAccordionSummary-root.MuiAccordionSummary-root.Mui-expanded.Mui-focused.Mui-focusVisible {
    outline: auto;
    border-color: transparent;
  }
  .MuiAccordionDetails-root.MuiAccordionDetails-root.MuiAccordionDetails-root
    > div {
    border-color: ${(props) => (0, ui_theme_1.fromTheme)(styles_1.bannerTypeColorMap[props.type].border)(props)};
  }
`;
exports.HeaderContainer = (0, styled_1.default)('span') `
  display: flex;
  align-items: center;
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  & > svg {
    flex: 1 0 auto;
  }
`;
//# sourceMappingURL=AccordionBanner.styles.js.map